<template>
  <div class="form-base">
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="v.issueNumber.$model"
          :errorMessages="getValidationErrorText(v.issueNumber)"
          label="Номер доверенности"
          outlined
        />
      </v-col>
      <v-col cols="12">
        <v-radio-group v-model="v.dateType.$model" row @change="clearDates">
          <v-radio label="Дата выдачи" :value="PROXY_DATE_TYPE.Single" />
          <v-radio label="Период выдачи" :value="PROXY_DATE_TYPE.Period" />
        </v-radio-group>
      </v-col>
      <v-col cols="6">
        <DateFieldCustom
          v-if="v.dateType.$model === PROXY_DATE_TYPE.Single"
          label="Дата выдачи"
          :value="v.issueDate.$model"
          @change="v.issueDate.$model = $event"
          :errorMessage="v.issueDate"
          :max="new Date().toISOString()"
        />
        <DateFieldCustom
          v-if="v.dateType.$model === PROXY_DATE_TYPE.Period"
          label="Дата начала периода"
          :value="v.issuePeriodFrom.$model"
          @change="v.issuePeriodFrom.$model = $event"
          :errorMessage="v.issuePeriodFrom"
          :max="formatDt(v.issuePeriodTo.$model)"
          :hideDetails="false"
        />
      </v-col>
      <v-col cols="6" v-if="v.dateType.$model === PROXY_DATE_TYPE.Period">
        <DateFieldCustom
          v-if="v.dateType.$model === PROXY_DATE_TYPE.Period"
          label="Дата окончания периода"
          :value="v.issuePeriodTo.$model"
          @change="v.issuePeriodTo.$model = $event"
          :errorMessage="v.issuePeriodTo"
          :min="formatDt(v.issuePeriodFrom.$model)"
        />
      </v-col>
      <v-col cols="12">
        <v-textarea
          v-model="v.summary.$model"
          :errorMessages="getValidationErrorText(v.summary)"
          outlined
          label="Краткое описание"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { and, required, requiredIf } from 'vuelidate/lib/validators';
import DateFieldCustom from '@/components/base/DateFieldCustom';
import {
  DATE_FORMAT,
  DATE_FUTURE,
  DATE_PAST,
  DATE_CORRECT_PERIOD,
  getValidationErrorText,
} from '@/utils/validate';
import { dateFormat } from '@/utils/services';
import { PROXY_DATE_TYPE } from '@/constants';

export const proxyInfoModel = {
  issueDate: '',
  issuePeriodFrom: '',
  issuePeriodTo: '',
  issueNumber: '',
  summary: '',
  dateType: PROXY_DATE_TYPE.Single,
};

export const proxyInfoValidation = {
  issueDate: {
    required: requiredIf((vm) => vm.dateType === PROXY_DATE_TYPE.Single),
    DATE: and(DATE_FORMAT, DATE_FUTURE, DATE_PAST),
  },
  issueNumber: {},
  issuePeriodFrom: {
    required: requiredIf((vm) => vm.dateType === PROXY_DATE_TYPE.Period),
    MIN_PERIOD_DATE: (_, vm) =>
      DATE_CORRECT_PERIOD(vm.issuePeriodFrom, vm.issuePeriodTo)(),
  },
  issuePeriodTo: {
    required: requiredIf((vm) => vm.dateType === PROXY_DATE_TYPE.Period),
  },
  summary: {
    required,
  },
  dateType: {},
};

function formatDt(val) {
  if (!val) return undefined;
  return dateFormat(val);
}

export default {
  name: 'ProxyInfo',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DateFieldCustom,
  },
  data: () => ({
    getValidationErrorText,
    PROXY_DATE_TYPE,
    formatDt,
  }),
  methods: {
    clearDates(val) {
      if (val === PROXY_DATE_TYPE.Single) {
        this.v.issuePeriodTo.$model = undefined;
        this.v.issuePeriodFrom.$model = undefined;
      } else {
        this.v.issueDate.$model = undefined;
      }
    },
  },
};
</script>
